import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte, AangifteBerekening, AangifteRapport, BokkzAlgDataService,
    Box1WinstUitOnderneming, Heffingskortingen, IncomeTaxEntity,
    OmschrijvingEnBedrag, Onderneming
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-ondernemer',
    templateUrl: './ondernemer.component.html',
    styleUrls: ['./ondernemer.component.scss'],
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        CommonModule
    ]
})
export class OndernemerComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public aangifteRapport = {} as AangifteRapport;
    public aangifteBerekening = {} as AangifteBerekening;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte;

    public aangeverNaam: string | undefined = '';
    public partnerNaam: string | undefined = '';
    public isDefAangifte = {} as boolean;

    public year = 0;

    private focusedElementId: string | null = null;
    public showSpinner = true;

    public heeftWuoStaking = false;
    public heeftVrijvallijfrente = false;

    public heeftRechtopOA = false;
    private partnerHtml = false;
    private heeftWuoPartner = false;
    private heeftWuoAangever = false;

    ondernemingen: Onderneming[] = [];
    public ondernemerForm = {} as FormGroup;
    public restantZAFg = {} as FormGroup;
    public krijgtWajong = {} as FormGroup;

    public hulpStartersaftrekForm = {} as FormGroup;
    public opgeslagenFormData: any = null;
    public dialogHulpmiddelStartersaftrek = false;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nee' }
    ];
    public optionsNeeJa: SelectFormControlItem<boolean>[] = [
        { value: false, label: 'Nee' },
        { value: true, label: 'Ja' }
    ];

    public meewerkUren: SelectFormControlItem<number>[] = [
        { value: 1, label: 'Nee, n.v.t.' },
        { value: 500, label: 'Ja, minder dan 525u' },
        { value: 800, label: 'Ja, 525u - 874u' },
        { value: 1000, label: 'Ja, 875u - 1.224u' },
        { value: 1500, label: 'Ja, 1.225u - 1.749u' },
        { value: 2000, label: 'Ja, 1.750u of meer' }];

    public aantalKerenBijAO: SelectFormControlItem<number>[] = [
        { value: 0, label: 'Geen' },
        { value: 1, label: '1 keer' },
        { value: 2, label: '2 keer' },
        { value: 3, label: 'Meer dan 2 keer' }];
    public aantalKerenZA: SelectFormControlItem<number>[] = [
        { value: 0, label: 'Geen' },
        { value: 1, label: '1 keer' },
        { value: 2, label: '2 keer' },
        { value: 3, label: 'Meer dan 2 keer' }];

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.ondernemerForm = this.fb.group<Box1WinstUitOnderneming>(this.createOndernemer());
        this.restantZAFg = this.fb.group({
            restantZelfstandigenaftrekUitEerdereJaren: this.fb.array<OmschrijvingEnBedrag>([]),
            heeftRestantZA: null as unknown as boolean
        });
        this.krijgtWajong = this.fb.group<Heffingskortingen>(this.createKrijgtWajongGroup());
        this.hulpStartersaftrekForm = this.fb.group(({
            heeftZA: true,
            nietElkJaarOndernemer: null as unknown as boolean,
            aantalKeerZA: null as unknown as number,
            inbrengInBV: null as unknown as boolean
        }));
    }

    public createOndernemer(ondernemer?: Box1WinstUitOnderneming) {
        return {
            krijgtZelfstandigenAftrek: ondernemer?.krijgtZelfstandigenAftrek || undefined,
            krijgtStartersAftrek: ondernemer?.krijgtStartersAftrek || undefined,
            krijgtStartersAftrekBijArbeidsOngeschiktheid: ondernemer?.krijgtStartersAftrekBijArbeidsOngeschiktheid || undefined,
            aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar: ondernemer?.aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar || undefined,
            krijgtSenOaftrek: ondernemer?.krijgtSenOaftrek || undefined,
            krijgtVerhogingSenOAftrek: ondernemer?.krijgtVerhogingSenOAftrek || undefined,
            speurOntwikkelaarVerklaringNummer: ondernemer?.speurOntwikkelaarVerklaringNummer || undefined,
            krijgtStakingsaftrek: ondernemer?.krijgtStakingsaftrek || undefined,
            bedragEerdereBenutteStakingsaftrek: ondernemer?.bedragEerdereBenutteStakingsaftrek || undefined,
            meewerkUren: ondernemer?.meewerkUren || undefined,
            oudedagsreserveBeginJaar: ondernemer?.oudedagsreserveBeginJaar || this.getBedragForBegin(),
            forDotatie: ondernemer?.forDotatie || undefined,
            vrijvalFORIvmPremieLijfente: ondernemer?.vrijvalFORIvmPremieLijfente || undefined,
            restantZelfstandigenaftrekUitEerdereJaren: ondernemer?.restantZelfstandigenaftrekUitEerdereJaren || undefined
        } as Box1WinstUitOnderneming;
    }

    get restantZelfstandigenaftrekUitEerdereJaren(): FormArray {
        return this.restantZAFg.get('restantZelfstandigenaftrekUitEerdereJaren') as FormArray;
    }

    addRijRestantZA(): void {
        this.restantZelfstandigenaftrekUitEerdereJaren.push(this.createRestantZAFormGroup());
    }

    verwijderRijRestantZA(index: number): void {
        this.restantZelfstandigenaftrekUitEerdereJaren.removeAt(index);
        this.saveForm();
    }


    createRestantZAFormGroup(restant?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: restant ? 'Restant zelfstandigenaftrek' : 'Restant zelfstandigenaftrek',
            bedrag: restant ? restant.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    public createKrijgtWajongGroup(wajong?: Heffingskortingen) {
        return {
            krijgtWajong: wajong?.krijgtWajong || undefined
        } as Heffingskortingen;
    }

    public getVrijvalLijfrente() {
        if (this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0]?.vrijvalFOR !== undefined) {
            this.heeftVrijvallijfrente = true;
        }
    }

    public getBedragForBegin() {
        let oudedagsreserveBeginJaar;
        if (this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].beginstandFOR !== undefined) {
            oudedagsreserveBeginJaar = this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].beginstandFOR;
        } else {
            oudedagsreserveBeginJaar = 0;
        }
        return oudedagsreserveBeginJaar;
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.setNaamAangeverEnPartner();
                this.heeftRechtopOA = false;
                if (!this.partnerHtml) {
                    if (this.heeftWuoAangever) {
                        this.heeftRechtopOA = true;
                    }
                    if (aangifte.box1?.winstUitOnderneming?.ondernemingen[0].datumStaking) {
                        const stakingJaar = new Date(aangifte.box1.winstUitOnderneming.ondernemingen[0].datumStaking).getFullYear();
                        if (stakingJaar === aangifte.aangifteJaar) {
                            this.heeftWuoStaking = true;
                        }
                    } else {
                        this.heeftWuoStaking = false;
                    }
                } else {
                    if (this.heeftWuoPartner) {
                        this.heeftRechtopOA = true;
                    }
                    if (aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].datumStaking) {
                        const stakingJaar = new Date(aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen[0].datumStaking).getFullYear();
                        if (stakingJaar === aangifte.aangifteJaar) {
                            this.heeftWuoStaking = true;
                        }
                    } else {
                        this.heeftWuoStaking = false;
                    }
                }
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner;
                    if (!partner) {
                        const partner = incomeTaxEntity.aangifte?.partnerAangifte?.aangever;
                        if (partner) {
                            this.partnerNaam = `${partner.voorletters} ${partner.tussenvoegsels ? partner.tussenvoegsels + ' ' : ''}${partner.achternaam}`;
                        }
                    } else {
                        const aangever = incomeTaxEntity.aangifte?.aangever;
                        if (aangever) {
                            this.partnerNaam = `${aangever.voorletters} ${aangever.tussenvoegsels ? aangever.tussenvoegsels + ' ' : ''}${aangever.achternaam}`;
                        }
                    }
                    this.heeftRechtopOA = false;
                    this.partnerHtml = partner;
                    if (!this.partnerHtml) {
                        if (this.heeftWuoAangever) {
                            this.heeftRechtopOA = true;
                        }
                    } else {
                        if (this.heeftWuoPartner) {
                            this.heeftRechtopOA = true;
                        }
                    }
                    this.ondernemerForm.reset();
                    this.krijgtWajong.reset();
                    this.updateForm();

                    // if (!partner) {
                    //     if (this.aangifte.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren?.at(0)) {
                    //         this.restantZAForm.patchValue(this.aangifte?.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren[0], {emitEvent: false});
                    //     }
                    // } else {
                    //     if (this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren?.at(0)) {
                    //         this.restantZAForm.patchValue(this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren[0], {emitEvent: false});
                    //     }
                    // }
                    this.dataService.heeftWinstUitOndernemingAangever.subscribe((booleanValiue) => {
                        this.heeftWuoAangever = booleanValiue;
                    });
                    this.dataService.heeftWinstUitOndernemingPartner.subscribe((booleanValiue) => {
                        this.heeftWuoPartner = booleanValiue;
                    });
                    this.getVrijvalLijfrente();
                });
                if (incomeTaxEntity.year !== undefined) {
                    this.year = incomeTaxEntity.year;
                }

            }
        });
        this.ondernemerForm.get('krijgtSenOaftrek')?.valueChanges.subscribe((value) => {
            if (!value) {
                this.ondernemerForm.patchValue({ krijgtVerhogingSenOAftrek: false }, { emitEvent: false });
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
        this.hulpStartersaftrekForm.valueChanges.subscribe((formData) => {
            this.opgeslagenFormData.reset();
            this.opslaanFormGegevens(formData);
        });
    }

    opslaanFormGegevens(formData: any): void {
        this.opgeslagenFormData = { ...formData };
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.ondernemerForm.dirty || this.restantZAFg.dirty || this.krijgtWajong.dirty;
    }

    private updateForm(): void {
        let ondernemer = this.aangifte?.box1?.winstUitOnderneming || {};
        this.partner.subscribe((partner) => {
            if (partner) {
                ondernemer = this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming || [];
            }
        });
        this.ondernemerForm.patchValue(ondernemer);

        let wajong = this.aangifte?.heffingskortingen ? this.aangifte?.heffingskortingen?.krijgtWajong : undefined;
        this.partner.subscribe((partner) => {
            if (partner) {
                wajong = this.aangifte?.partnerAangifte?.heffingskortingen ? this.aangifte?.partnerAangifte?.heffingskortingen?.krijgtWajong : undefined;
            }
        });
        this.krijgtWajong.patchValue({ krijgtWajong: wajong });

        let restantZALijst = this.aangifte?.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                restantZALijst = this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.restantZelfstandigenaftrekUitEerdereJaren || [];
            }
        });
        const formArray = this.restantZAFg.get('restantZelfstandigenaftrekUitEerdereJaren') as FormArray;
        while (formArray.length > restantZALijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < restantZALijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(restantZALijst[i]);
            } else {
                // Add new control
                const formGroup = this.createRestantZAFormGroup(restantZALijst[i]);
                formArray.push(formGroup);
            }
        }

        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
        this.getVrijvalLijfrente();
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    winstUitOnderneming: {
                        ...this.ondernemerForm.value,
                        restantZelfstandigenaftrekUitEerdereJaren: this.restantZAFg.value.restantZelfstandigenaftrekUitEerdereJaren,
                        ondernemingen: this.aangifte.box1?.winstUitOnderneming?.ondernemingen
                    }
                },
                heffingskortingen: {
                    ...this.krijgtWajong.value,
                    rechtOpAowAlleenstaande: this.aangifte.heffingskortingen?.rechtOpAowAlleenstaande
                }
            } as Aangifte;
            this.ondernemerForm.updateValueAndValidity();
            this.restantZAFg.markAsDirty();
            this.ondernemerForm.markAsDirty();
            this.krijgtWajong.markAsDirty();
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        winstUitOnderneming: {
                            ...this.ondernemerForm.value,
                            restantZelfstandigenaftrekUitEerdereJaren: this.restantZAFg.value.restantZelfstandigenaftrekUitEerdereJaren,
                            ondernemingen: this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen
                        }
                    },
                    heffingskortingen: {
                        ...this.krijgtWajong.value,
                        rechtOpAowAlleenstaande: this.aangifte.partnerAangifte?.heffingskortingen?.rechtOpAowAlleenstaande
                    }
                }
            } as Aangifte;
            this.ondernemerForm.updateValueAndValidity();
            this.restantZAFg.markAsDirty();
            this.ondernemerForm.markAsDirty();
            this.krijgtWajong.markAsDirty();
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
    }

    private setNaamAangeverEnPartner() {
        if (this.aangifte.aangever != null && this.aangifte.aangever.achternaam != null) {
            let voorletters = '';
            let tussenvoegsel = '';
            let achternaam = '';
            if (this.aangifte.aangever.voorletters) {
                voorletters = this.aangifte.aangever.voorletters.replace(/\./g, '');
            }
            if (this.aangifte.aangever.tussenvoegsels) {
                tussenvoegsel = this.aangifte.aangever.tussenvoegsels;
            }
            if (this.aangifte.aangever.achternaam) {
                achternaam = this.aangifte.aangever.achternaam;
            }
            if (tussenvoegsel) {
                this.aangeverNaam = voorletters + ' ' + tussenvoegsel + ' ' + achternaam;
            } else {
                this.aangeverNaam = voorletters + ' ' + achternaam;
            }
        } else {
            this.aangeverNaam = 'niet ingevuld';
        }

        if (this.aangifte.partnerAangifte != null && this.aangifte.partnerAangifte.aangever != null &&
            this.aangifte.partnerAangifte.aangever.achternaam != null) {
            let voorletters = '';
            let tussenvoegsel = '';
            let achternaam = '';
            if (this.aangifte.partnerAangifte.aangever.voorletters) {
                voorletters = this.aangifte.partnerAangifte.aangever.voorletters.replace(/\./g, '');
            }
            if (this.aangifte.partnerAangifte.aangever.tussenvoegsels) {
                tussenvoegsel = this.aangifte.partnerAangifte.aangever.tussenvoegsels;
            }
            if (this.aangifte.partnerAangifte.aangever.achternaam) {
                achternaam = this.aangifte.partnerAangifte.aangever.achternaam;
            }

            if (tussenvoegsel) {
                this.partnerNaam = voorletters + ' ' + tussenvoegsel + ' ' + achternaam;
            } else {
                this.partnerNaam = voorletters + ' ' + achternaam;
            }
        } else {
            this.partnerNaam = 'niet ingevuld';
        }
    }

    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte &&
                this.aangifte.partnerAangifte &&
                this.aangifte.partnerAangifte.box1 &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.aangifte &&
                this.aangifte.box1 &&
                this.aangifte.box1.winstUitOnderneming &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }

}
